<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col text-right">
          <router-link v-if="edit_permission" to="/ejercicios/create"><base-button type="primary" size="sm"> Crear ejercicio</base-button></router-link>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th></th>
          <th>Ejercicios</th>
          <th>Nombre</th>
          <th>Descripción</th>
          
        </template>

        <template slot-scope="{row}">
          <td class="text-left">
            <base-dropdown   class="dropdown  por-arriba"
                           position="left">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <router-link :to="{ name: 'Ver Ejercicio', params: { ejercicioId: row.id}}" class="dropdown-item"><span>Ver</span></router-link>
                <router-link v-if="edit_permission" :to="{ name: 'Editar Ejercicio', params: { ejercicioId: row.id}}" class="dropdown-item"><span>Editar</span></router-link>
                <base-button v-if="edit_permission" block  class="dropdown-item" @click="deleteEjercicio(row.id)">
                  <span>Eliminar</span>
                </base-button>
              </template>
            </base-dropdown>
          </td>

          <th scope="row">
            <div class="media align-items-center" v-if="row.ejercicio_img != null">
              <a href="#" class="avatar rounded-circle mr-3">
                <img alt="Image placeholder" :src="row.ejercicio_img">
              </a>
              <div class="media-body">
                <span class="name mb-0 text-sm"></span>
              </div>
            </div>
          </th>
          <th class="budget">
            <router-link :to="{ name: 'Ver Ejercicio', params: { ejercicioId: row.id}}"><span>{{row.ejercicio_name}}</span></router-link>
          </th>
          <td class="budget">
            {{row.ejercicio_description.substring(0,50)}}...
          </td>
          
          

        </template>

      </base-table>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      
    </div>

  </div>
</template>
<script>
import { db } from '../../firebaseDb';
import { auth } from '../../firebaseDb';
  export default {
    name: 'ejercicios-table',
    props: {
      type: {
        type: String
      },
      title: String,
      category: String
    },
    data() {
      return {
        tableData: [],
        user: auth.currentUser,
        edit_permission: false
      }
    },
    created: function() {
      this.creado();
    },
    methods: {
      creado(){
        db.collection('ejercicios').where('ejercicio_category', '==', this.category)
       .onSnapshot({ includeMetadataChanges: true }, (snapshot) => {
         this.tableData = [];
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.ejercicio_description = item.ejercicio_description.replace(/(<([^>]+)>)/gi, " ")
          this.tableData.push(item)
        })
      })
      var self = this
      db.collection('users').doc(this.user.uid).get()
      .then(function(doc){
        if(doc.exists){
          try{
            if (doc.data().rol == 'admin') {
              self.edit_permission = true
            }
          }catch(error){
            console.log(error)
          }
        }
      })
      },
      deleteEjercicio(id){
        if (window.confirm("¿Está seguro de eliminar este ejercicio?")) {
          db.collection('ejercicios').doc(id).delete().then(() => {
              console.log("Document deleted!");
              this.tableData = [];
              this.creado();
          })
          .catch((error) => {
              console.error(error);
          })
        }
      }
    } 
  }
</script>
<style>
.por-arriba{
      position: absolute;  
}
</style>
